import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { Fetching } from 'components/Fetching/Fetching';
import { SectionList } from 'components/SectionList/SectionList';
import type { RootState } from 'reducers/types';
import { getRecipient, getSectionsByEntity } from 'selectors';
import { useTranslations } from 'utils/translations/useTranslations';

type PropsFromRedux = ConnectedProps<typeof connector>;

const ENTITY = 'recipient';

const RecipientInformationComponent = ({
  recipient,
  sections,
}: PropsFromRedux) => {
  const i18n = useTranslations();

  const title = i18n.t('recipientInformation.title', {
    recipient: recipient.name as string,
  });

  return (
    <>
      <Fetching entity="order" />
      {/* @ts-expect-error need to fix SectionList */}
      <SectionList sections={sections} title={title} entity={ENTITY} />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  recipient: getRecipient(state),
  sections: getSectionsByEntity(state, ENTITY),
});

const connector = connect(mapStateToProps);
const RecipientInformation = connector(RecipientInformationComponent);

export { RecipientInformation };
